function pluralize(count, singular, plural) {
  return (count === 1) ? singular : plural;
}

export {
  pluralize
}
